import { Box, Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../../../atomic/molecules';
import EditIcon from '@mui/icons-material/EditSharp';
import { useSelector } from 'react-redux';
import { CustomerCommand } from '../../../../services/command';
import Swal from 'sweetalert2';
import { SCUILoadingLinear } from '../../../../atomic/atoms';
import { NoResultFoundComponent } from '../NoResultFoundComponent/NoResultFoundComponent';
import { GenericCustomerAddress } from './GenericCustomerAddress';
import { CargoManagementQuery } from '../../../../services/query';
import { AddressEntityType } from '../../../../types/enums/addressEntityType-enum';
import { CAIP } from './customerAddressInformationPaper.classes';
interface IProps {
    datas?: any;
}
export const CustomerAdressInformationPaper: FC<IProps> = ({ datas }) => {
    const [refresh, setRefresh] = useState(false);
    const { t } = useTranslation();
    const [adressList, setAdressList] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [adressForDrawerContent, setAdressForDrawerContent] = React.useState<any>();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const activeIndex: any = useSelector((state: any) => state?.country);
    const countryId = activeIndex?.country;
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [addressEntityTypeListByCountryId, setAddressEntityTypeListByCountryId] = useState<any>();

    const columns: ExtendedGridColDef[] = [
        { field: 'customerAddressId', headerName: t('customerInformation.addressNo'), flex: 1 },
        {
            field: 'addressDefinition',
            headerName: t('customerInformation.addressDefination'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.addressDefinition}>
                        <p style={{ fontSize: '11px', fontFamily: 'Nunito', fontWeight: '400' }}>
                            {params.row.addressDefinition}
                        </p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'address',
            headerName: t('general.address'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.address}>
                        <p style={{ fontSize: '11px', fontFamily: 'Nunito', fontWeight: '400' }}>
                            {params.row.address}
                        </p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'countryZoneName',
            headerName: t('general.region'),
            flex: 1,
            hide: !addressEntityTypeListByCountryId?.some(
                (item: any) => item.addressEntityTypeId === AddressEntityType.Region
            ),
        },
        {
            field: 'cityName',
            headerName: t('excel.cityName'),
            flex: 1,
            hide: !addressEntityTypeListByCountryId?.some(
                (item: any) => item.addressEntityTypeId === AddressEntityType.City
            ),
        },
        {
            field: 'countyName',
            headerName: t('excel.countyName'),
            flex: 1,
            hide: !addressEntityTypeListByCountryId?.some(
                (item: any) => item.addressEntityTypeId === AddressEntityType.County
            ),
        },
        {
            field: 'neighborhoodName',
            headerName: t('general.neighborhood'),
            flex: 1,
            hide: !addressEntityTypeListByCountryId?.some(
                (item: any) => item.addressEntityTypeId === AddressEntityType.Neighborhood
            ),
        },
        {
            field: 'customizedName',
            headerName: t('general.postalCode'),
            flex: 1,
            hide: !addressEntityTypeListByCountryId?.some(
                (item: any) => item.addressEntityTypeId === AddressEntityType.PostalCode
            ),
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.customizedName}>
                        <Typography>{params.row.customizedName}</Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: 'streetName',
            headerName: t('addressDetail.streetName'),
            flex: 1,
            hide: !addressEntityTypeListByCountryId?.some(
                (item: any) => item.addressEntityTypeId === AddressEntityType.Street
            ),
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.streetName}>
                        <Typography>{params.row.streetName}</Typography>
                    </Tooltip>
                );
            },
        },
        { field: 'countryCode', headerName: t('general.country'), flex: 1 },
        { field: 'combinedPhoneNumber', headerName: t('general.phoneNumber'), flex: 1 },
        {
            field: 'edit',
            headerName: t('general.edit'),
            flex: 1,
            renderCell: (params) => {
                const onclick = () => {
                    onDrawerOpen();
                    setAdressForDrawerContent(params.row);
                };
                return (
                    <IconButton className={CAIP.inputIconButtonEditRow} onClick={onclick}>
                        <EditIcon />
                    </IconButton>
                );
            },
        },
    ];
    const CountryAddressRulesforCountryId = async () => {
        try {
            CargoManagementQuery.CountryAddressRulesforCountryId().then((res: any) => {
                setAddressEntityTypeListByCountryId(res.data.countryAddressRules);
            });
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetCustomerAddress = async () => {
        setPageLoading(true);
        let params = {
            CustomerId: datas.customer.customerId,
            CountryId: countryId,
        };
        CustomerCommand.GetCustomerAddress(params)
            .then((res: any) => {
                if (res) {
                    if (res.customerAddresses) {
                        setAdressList(res.customerAddresses);
                    }
                }
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'error');
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
                setPageLoading(false);
            });
    };
    useEffect(() => {
        // GetCustomerWithPhoneNumber();
        GetCustomerAddress();
        CountryAddressRulesforCountryId();
    }, [refresh]);

    return (
        <Paper
            className={CAIP.rootPaper}
            style={{
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 1,
            }}
        >
            <SCUILoadingLinear display={loading} />
            <SCUIGeneralDrawer
                open={drawerOpen}
                width={'350px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        onDrawerClose();
                    }
                }}
            >
                <Box className={CAIP.drawerBody} sx={{ padding: '16px' }}>
                    <GenericCustomerAddress
                        detail={adressForDrawerContent}
                        onClose={onDrawerClose}
                        setRefresh={setRefresh}
                        addressEntityTypeListByCountryId={addressEntityTypeListByCountryId}
                    />
                </Box>
            </SCUIGeneralDrawer>
            {adressList && adressList.length > 0 ? (
                <Grid container justifyContent={'space-between'} sx={{ margin: '1rem', padding: '8px' }}>
                    <h4 className={CAIP.sectionTitle}>{t('customerInformation.addressInformation')}</h4>
                    <Grid
                        className={CAIP.gridWrapper}
                        sx={{ marginRight: '1.5rem' }}
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <Box className={CAIP.datagrid}>
                            <SCUICustomDataGrid rows={adressList} columns={columns} randomId />
                        </Box>
                    </Grid>
                </Grid>
            ) : !pageLoading ? (
                <NoResultFoundComponent errorText={t('customerInformation.addressInformationErrorMessage')} />
            ) : (
                <SCUILoadingLinear display={pageLoading} />
            )}
        </Paper>
    );
};
